import React from "react";
import {Translate, withLocalize} from "react-localize-redux";
import {Dropdown, Menu} from 'semantic-ui-react';
import 'moment/locale/de';
import moment from 'moment';

const LanguageToggle = ({languages, activeLanguage, setActiveLanguage, mobile}) => {

    if (mobile) {
        return (
            <Menu.Item>
                <Menu.Header>
                    <Translate id='general.language'>
                        Language
                    </Translate>
                </Menu.Header>
                <Menu.Menu>
                    {languages.filter((lang)=> lang!==activeLanguage).map(lang => (
                        <Menu.Item key={lang.code}>
                            <div onClick={() => {
                                localStorage.setItem('defaultLanguage', lang.code);
                                setActiveLanguage(lang.code);
                                moment.locale(lang.code);
                            }}>
                                {lang.name}
                            </div>
                        </Menu.Item>
                    ))}
                </Menu.Menu>
            </Menu.Item>
        );
    }
    return (
        <Translate>
            {
                ({translate}) =>
                    <Dropdown item text={translate('general.language')}>
                        <Dropdown.Menu>
                            {languages.filter((lang)=> lang!==activeLanguage).map(lang => (
                                <Dropdown.Item key={lang.code}
                                               onClick={() => {
                                                   localStorage.setItem('defaultLanguage', lang.code);
                                                   setActiveLanguage(lang.code);
                                                   moment.locale(lang.code);
                                               }}>{lang.name}</Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>

            }

        </Translate>
    );

};

export default withLocalize(LanguageToggle);



// WEBPACK FOOTER //
// ./src/components/Homepage/components/LanguageToggle/index.js